import React, {  useEffect } from "react";
import {  useNavigate } from "react-router-dom";

import wlcm from './../../../../assets/images/welcomepages/Selection.png';
import './Page1.scss'; 


function IntroPage() {
  const navigate = useNavigate();
  useEffect(() => {
   
    setTimeout(() => {
      navigate("/dashboard");
    }, 3500);
  }, []);
  return (
    <div>
      <div className="page-container">
        <p className="welcome-text">
          Welcome! You're about to enter a whole new world of business growth.
        </p>

        {/* Small line under text */}
        <div className="underline"></div>

        {/* Image */}
        <img src={wlcm} alt="Welcome Icon" className="welcome-img" />

        {/* Dotted Loader */}
        <div className="loading-section">
          <div className="loader"></div>
          <p className="loading-text">Building your new workplace</p>
        </div>
      </div>
    </div>
  );
}

export default IntroPage;
